import { render } from "./SiteMapView.vue?vue&type=template&id=36956311"
import script from "./SiteMapView.vue?vue&type=script&lang=js"
export * from "./SiteMapView.vue?vue&type=script&lang=js"

import "./SiteMapView.vue?vue&type=style&index=0&id=36956311&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__